import {ResourceRequestParams} from "./resource-request-params";
import {ARGS} from "../../../core/bootstrap/args";
import {IMAGE_DEFAULT_FORMATS} from "../../../core/app/consts";
import {computed, runInAction, observable, makeObservable} from 'mobx';

export class ImageRequestParams extends ResourceRequestParams {
  resourceName: String;
  alt: String;
  title: String;
  _width: Number;
  _height: Number;
  isRound: Boolean;
  version: Number;
  ratio: Number;
  c: String;
  g: String;
  @observable _theme: String;

  constructor(params: ImageRequestParams) {
    super(ARGS.IMAGES_API);

    this.resourceName = params.resourceName;
    this.alt = params.alt || '';
    this.title = params.title || '';
    this.version = params.version;
    this.isRound = typeof params.isRound === "boolean" ? params.isRound : true;
    this._width = params.width;
    this._height = params.height;
    this.ratio = params.ratio || 1;
    this.c = params.c || 'limit';
    this.g = params.g;
    this.theme = null;
    this.color = params.color;

    makeObservable(this);
  }

  @computed get theme(): String {
    return this._theme;
  }

  set theme(theme) {
    runInAction(() => {
      this._theme = theme;
    })
  }

  get width(): Number {
    return this._width;
  }

  get height(): Number {
    return this._height;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.PNG;
  }

  get quality(): String {
    return 'auto:eco';
  }

  get versionPath(): String {
    return this.version ? `/v${this.version}` : '';
  }

  get rgb(): String {
    return this.color ? `co_rgb:${this.color.replace('#', '')},e_colorize:100` : '';
  }

  get params() {
    const params = [];

    this.defaultFormat && params.push(`f_${this.defaultFormat}`);

    !isNaN(this.width) && params.push(`w_${this.width}`);
    !isNaN(this.height) && params.push(`h_${this.height}`);

    this.c && params.push(`c_${this.c}`);
    this.angle && params.push(`a_${this.angle}`);
    this.quality && params.push(`q_${this.quality}`);
    this.ratio && params.push(`dpr_${this.ratio}`);
    this.g && params.push(`g_${this.g}`);
    this.color && params.push(this.rgb);


    return params.join(',');
  }

  get pathPostfix(): String {
    return `${this.versionPath}/${this.resourceName}`;
  }

  toString(): String {
    const url = `${this.baseUrl}${this.params}${this.pathPostfix}`;

    return url;
  }
}
